$(document).ready(function() {
    console.log('running');
    var productDataElement = $('#product-data');
    var productData = JSON.parse(productDataElement.text());

    if (!productData.products || !Array.isArray(productData.products)) {
        console.error("Invalid product data");
        return;
    }

    let handle_and_sku = [];

    // Collect product information
    productData.products.forEach(product => {
        let handle = product.handle;
        let sku = product.variants[0].sku;
        let variants = product.variants;
        let tags = product.tags; // Array of tags
        let newObj = {
            id: product.id,
            handle: handle,
            sku: sku,
            variant: variants,
            title: product.title,
            tags: tags // Store the tags in the object
        };
        handle_and_sku.push(newObj);
    });

    function addSkuToProductCards() {
        $('.spf-product-card').each(function() {
            var productHandle = $(this).find('.spf-product-card__title a').attr('href').split('/').pop();
            var product = handle_and_sku.find(p => p.handle === productHandle);

            if (product) {
                var sku = product.sku;
                var variants = product.variant;
                var firstVariant = variants[0];
                var hasMultipleVariants = variants.length > 1;

                // Check if the div has already been appended
                if (!$(this).find(`.zoomywishid-${product.id}`).length) {
                    // Append the new div with the required data attributes
                    var zoomyDiv = `
                    <div class="zoomywishid zoomywishid-${product.id}" 
                         data-product-id="${product.id}" 
                         data-handle="${product.handle}" 
                         data-image="${firstVariant.featured_image ? firstVariant.featured_image.src : ''}" 
                         data-variantname="${firstVariant.title}" 
                         data-title="${product.title}" 
                         data-variant="${firstVariant.id}" 
                         data-price="${firstVariant.price}">
                      <div class="zoomywishidheart" style="position:relative;">
                        <input type="checkbox" data-id="${product.id}" 
                               class="zoomycheck checkbox-${product.id}" 
                               id="checkbox-${product.id}">
                        <label for="checkbox-${product.id}">
                          <p class="zooomywishmsg zooomywishmsg-${product.id}">
                            <i class="fa fa-heart-o" style="color: #000000;"></i>
                          </p>
                        </label>
                      </div>
                    </div>`;
                    $(this).find('.spf-product__info').before(zoomyDiv);
                }

                // Handle "Add to Cart" button click
                $(this).find('.spf-product__form-btn-addtocart').off('click').on('click', function(e) {
                    e.preventDefault(); // Prevent default form submission

                    var productCard = $(this).closest('.spf-product-card'); // Get the closest product card element
                    var variantId = productCard.find('select.spf-product__variants').eq(0).val(); // Retrieve the variant ID from the parent element

                    // Ensure variantId is valid
                    if (variantId && variantId.trim() !== "") {
                        // Add product to cart via AJAX
                        fetch('/cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    id: variantId,
                                    quantity: 1
                                }),
                            })
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(`HTTP error! Status: ${response.status}`);
                                }
                                return response.json();
                            })
                            .then(data => {
                                console.log('Product added to cart:', data);
                                // Update cart UI here
                                updateCartUI();
                                // Open the mini cart drawer
                                document.querySelector('body').classList.add('header-mini-cart-open', 'drawer-open');
                            })
                            .catch(error => {
                                console.error('Error adding product to cart:', error);
                                alert('There was a problem adding the product to the cart.');
                            });
                    } else {
                        console.error('Variant ID is missing or invalid.');
                        alert('Product cannot be added to the cart. Please try again.');
                    }
                });

                // Change "Add to Cart" button to "View Options" for products with multiple variants
                if (hasMultipleVariants) {
                    var addToCartButton = $(this).find('.spf-product__form-btn-addtocart');
                    if (!$(this).find('.spf-product__form-btn-viewoptions').length) {
                        addToCartButton.replaceWith($('<a>', {
                            href: `/products/${product.handle}`,
                            class: 'spf-product__form-btn-viewoptions btn',
                            text: 'View Options'
                        }));
                    }
                }
            }
        });
    }



    // Initialize cart on page load
    function initializeCart() {
        updateCartUI(); // Call to update cart UI on load
    }

    setTimeout(function() {
        addSkuToProductCards();
    }, 3000);

    // Initialize the cart on page load
    initializeCart();

    // Reapply changes when pagination is clicked
    $(document).on('click', '.pagination span', function() {
        setTimeout(function() {
            addSkuToProductCards();
        }, 1000);
    });

    // Reapply changes at intervals to catch dynamic changes
    setInterval(function() {
        addSkuToProductCards();
    }, 1000);
});



function updateCartUI() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            console.log('Updated cart:', cart);

            // Check if the cart quantity element exists
            if (!$('.head-slot-cart-link-quantity').length) {
                // Create and append the cart quantity element if it does not exist
                $('<span>', {
                    class: 'head-slot-cart-link-quantity',
                    text: cart.item_count
                }).appendTo('.head-slot-nav-link.head-slot-cart-link');
            } else {
                // Update the cart quantity if the element exists
                $('.head-slot-cart-link-quantity').text(cart.item_count);
            }

            // Clear current mini cart content
            var miniCartContent = $('.drawer-content-inner');
            miniCartContent.empty();

            var indexy = 1;

            // Add each item from the cart to the mini cart
            if (cart.item_count > 0) {
                cart.items.forEach(item => {

                    var properties = item.properties;

                    var variants = item.options_with_values;

                    var variants_html = '';

                    var properties_html = '';

                    $.each(properties, function(index, property) {

                        properties_html += `<p class="mini-cart-item-eyebrow-sku">${index} : ${property}</p>`

                    })


                    $.each(variants, function(index, variant) {

                        if (variant.value !== 'Default Title') {

                            variants_html += `<p class="mini-cart-item-eyebrow-sku">${variant.name} : ${variant.value}</p>`

                        }


                    })

                    // properties.forEach(function(property, index){

                    //   properties_html += `<p class="mini-cart-item-eyebrow-sku">${index} : ${property}</p>`

                    // });

                    console.log(properties_html);

                    var itemHtml = `<div class="mini-cart-item-list" >
                            <div class="mini-cart-item js-cart-item" id="MiniCartItem-${indexy}">
                                <div class="mini-cart-item-image-wrap">
                                    <a href="/products/${item.handle}?variant=${item.variant_id}">
                                        <img src="${item.image}" alt="${item.title}" width="140" height="140" loading="lazy" srcset="${item.image}?width=70 1x, ${item.image}?width=140 2x">
                                        <span class="visually-hidden">${item.title}</span>
                                    </a>
                                </div>
                                <div class="mini-cart-item-info">
                                    <h3 class="mini-cart-item-heading typography-body">
                                        <a href="/products/${item.handle}?variant=${item.variant_id}">${item.title}</a>
                                    </h3>
                                    <div class="mini-cart-item-price">
                                        <div class="mini-cart-item-final-price">
                                            $${(item.line_price / 100).toFixed(2)}
                                        </div>
                                    </div>
                                    <p class="mini-cart-item-eyebrow-sku">SKU# : ${item.sku}</p>
                                     ${variants_html} 
                                    ${properties_html}
                                    <dl class="mini-cart-variations-list"></dl>
                                    <p class="mini-cart-variation-option"></p>
                                    <div class="mini-cart-item-actions">
                                        <quantity-input class="quantity-input">
                                            <button type="button" name="minus" class="quantity-input-button quantity-input-minus no-js-hidden">
                                                −
                                                <span class="visually-hidden">Decrease quantity for ${item.title}</span>
                                            </button>
                                            <label for="Mini-Cart-Quantity-${indexy}" class="visually-hidden">Quantity</label>
                                            <input name="updates[]" type="number" class="quantity-input-field" min="1" value="${item.quantity}" id="Mini-Cart-Quantity-${indexy}" data-index="${indexy}" aria-label="Quantity for ${item.title}">
                                            <button type="button" name="plus" class="quantity-input-button quantity-input-plus no-js-hidden">
                                                +
                                                <span class="visually-hidden">Increase quantity for ${item.title}</span>
                                            </button>
                                        </quantity-input>
                                        <cart-remove-button id="Remove-${indexy}" data-index="${indexy}">
                                            <a href="/cart/change?id=${item.variant_id}&quantity=0" class="mini-cart-item-remove link-text">Remove</a>
                                        </cart-remove-button>
                                    </div>
                                </div>
                            </div>
                        `;
                    miniCartContent.append(itemHtml);

                    indexy++;
                });

                // Update or create the mini cart totals
                if ($('#mini-cart-totals').length) {
                    // If the totals element exists, update its value
                    $('#mini-cart-totals').html(`<span>Total</span><span>$${(cart.total_price / 100).toFixed(2)} USD</span>`);
                } else {
                    // If the totals element does not exist, create it
                    $('#header-mini-cart-footer').append(`
                            <div class="mini-cart-footer">
                              <div id="mini-cart-totals" class="mini-cart-recap">
                                <span>Total</span>
                                <span>$${(cart.total_price / 100).toFixed(2)} USD</span>
                              </div>
                            
                              <div class="mini-cart-footer-actions">
                                <a href="/cart" class="button button-tertiary btn">
                                  VIEW CART
                                  <span class="angle angle-right">
                                    <span class="angle-icon"></span>
                                  </span>
                                </a>
                            
                                <button type="submit" class="button btn" name="checkout">
                                  Check out
                                  <span class="angle angle-right">
                                    <span class="angle-icon"></span>
                                  </span>
                                </button>
                              </div>
                            
                              <span class="spinner-sm"></span>
                            </div>
                        `);
                }
            } else {
                miniCartContent.append('<p>Your cart is empty.</p>');

                // Remove the mini cart totals if there are no items
                $('#mini-cart-totals').remove();
            }
        })
        .catch(error => console.error('Error updating cart UI:', error));



}



function check_license() {


    var element_val = $('input[name="properties[Dental License]"]').val().trim();

    if ((element_val && /^[A-Za-z0-9]+$/.test(element_val)) && (element_val.length >= 5 && element_val.length <= 10)) {
        $('.button-add-to-cart').attr('disabled', false);
        $('#error_box').text('');
    } else {

        $('.button-add-to-cart').attr('disabled', true);
                if(element_val.length <= 0){
          $('#error_box').text('Enter License Number');
        }else{
        $('#error_box').text('Invalid License Number');
          
        }
    }

}


function updateCartItemProperties(lineItemKey, newProperties) {

    var quantity = parseInt($('input[name="quantity"]').val());

    console.log('Updating cart item properties:', {
        id: lineItemKey,
        properties: newProperties
    });

    fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: lineItemKey,
                quantity: quantity,
                properties: newProperties
            })
        })
        .then(response => response.json())
        .then(cart => {
            console.log('Cart item properties updated:', cart);
        })
        .catch(error => console.error('Error updating cart item properties:', error));
}

function submitted(form) {
    var formdata = new FormData(form);

    formdata.forEach(function(value, key) {
        if (key == 'id') {
            var variant_id = value;

            setTimeout(function() {
                $.getJSON('/cart.js', function(cart) {
                    $.each(cart.items, function(index, item) {
                        if (variant_id == item.id && $.isEmptyObject(item.properties)) {
                            console.log('Found item to update:', item);

                            setTimeout(function() {

                                updateCartUI();
                            }, 1000);

                            var line_obj = {};
                            $('.line_item').each(function(index, element) {
                                var el = $(element);

                                if (el.val()) {
                                    var property = el.attr('data_prop');
                                    line_obj[property] = el.val();
                                }
                            });

                            if (!$.isEmptyObject(line_obj)) {

                                console.log('Properties to update:', line_obj);

                                updateCartItemProperties(item.key, line_obj);

                            }




                            var element_val = $('input[name="license_number"]').val();

                            if (element_val && /^[A-Za-z0-9]+$/.test(element_val)) {
                                var license = {
                                    'License Number': element_val
                                };

                                updateCartItemProperties(item.key, license);
                            }




                        }
                    });
                });
            }, 1000);
        }
    });
}